export default {
  name: 'pagination',

  props: {
    value: { type: Number, required: true},
    total: { type: Number, required: true},
    pagesToShow: { type: Number, required: false, default: 5},
    first: { type: String, default: 'First' },
    last: { type: String, default: 'Last' },
  },

  data () {
    return {
      current: this.value
    }
  },

  watch: {
    value (val) {
      this.current = val
    },

    current (val) {
      this.$emit('input', val)
    }
  },

  computed: {
    pageRange() {
      let start = Math.max(this.current - Math.floor(this.pagesToShow / 2), 0)
      let end = start + this.pagesToShow
      if(end > this.total) {
        start = Math.max(start - (end - this.total), 0)
        end = this.total
      }

      return Array.from({length: (end - start)}, (v, k) => k + start)
    }
  }
}
